import React from 'react';
import { IonContent, IonPage, IonSearchbar } from '@ionic/react';
import './Slide1_bis.css'

function Slide1({urlImage, title} : {urlImage: string, title: string}) {
  return (
    <>
      <IonContent id='Slide1'>
          <div className="content">
              <video autoPlay controls src={urlImage}>
                <source src={urlImage} type="video/mp4"/>
              </video>
              <div className="leyenda">
                  {title}
              </div>
          </div>
      </IonContent>
    </>
  );
}
export default Slide1;